$('body').on('click', '.read-more .c-btn', function (e) {
  e.preventDefault()
  const content = $(this).closest('.read-more').find('.read-more-content')
  $(this).hide()
  content.show()
})
